const API_BASE = process.env.REACT_APP_API_BASE_URL || ''; // e.g. "https://dev-api.prospectpulse.in/api"

const apiOrigin = (() => {
  try {
    return new URL(API_BASE).origin;
  } catch {
    return '';
  }
})();

const FACEBOOK_APP_ID = 755911500418069;
const LINKEDIN_APP_ID = '77zw28l1wukz6z';    
const REDDIT_APP_ID = 'hNkGbRqL-im_FRdPLxs-fQ';

const SocialAuthService = {
  getFacebookAuthUrl({ redirectPath = '/api/SocialAuth/facebook/auth/callback', scopes = 'public_profile,email,pages_manage_posts,pages_read_engagement,pages_show_list' } = {}) {
    const redirectUri = `${apiOrigin}${redirectPath.startsWith('/') ? redirectPath : '/' + redirectPath}`;
    const url = `https://www.facebook.com/v21.0/dialog/oauth?client_id=${encodeURIComponent(FACEBOOK_APP_ID)}&redirect_uri=${encodeURIComponent(redirectUri)}&scope=${encodeURIComponent(scopes)}&response_type=code`;
    return url;
  },

  getLinkedInAuthUrl({ redirectPath = '/api/SocialAuth/linkedin/auth/callback', scopes = 'openid profile email w_member_social', state = 'xyz123' } = {}) {
    const redirectUri = `${apiOrigin}${redirectPath.startsWith('/') ? redirectPath : '/' + redirectPath}`;
    const url = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${encodeURIComponent(LINKEDIN_APP_ID)}&redirect_uri=${encodeURIComponent(redirectUri)}&scope=${encodeURIComponent(scopes)}&state=${encodeURIComponent(state)}`;
    return url;
  },

  getRedditAuthUrl({ redirectPath = '/api/SocialAuth/reddit/auth/callback', scopes = 'identity submit', state = 'xyz123', duration = 'temporary' } = {}) {
    const redirectUri = `${apiOrigin}${redirectPath.startsWith('/') ? redirectPath : '/' + redirectPath}`;
    const url = `https://www.reddit.com/api/v1/authorize?client_id=${encodeURIComponent(REDDIT_APP_ID)}&response_type=code&state=${encodeURIComponent(state)}&redirect_uri=${encodeURIComponent(redirectUri)}&duration=${encodeURIComponent(duration)}&scope=${encodeURIComponent(scopes)}`;
    return url;
  }
};

export default SocialAuthService;
